import AHttpService from '@d-services/a-http-service/a-http-service';
import URLS from '@d-shared/urls/urls';

class BookVotesService extends AHttpService {
  async addDownvote(bookSlug) {
    const url = URLS.api.book.addDownvote.replace('<book-slug>', bookSlug);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async addUpvote(bookSlug) {
    const url = URLS.api.book.addUpvote.replace('<book-slug>', bookSlug);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async removeDownvote(bookSlug) {
    const url = URLS.api.book.removeDownvote.replace('<book-slug>', bookSlug);
    const response = await this._http.delete(url);
    return response.data;
  }

  async removeUpvote(bookSlug) {
    const url = URLS.api.book.removeUpvote.replace('<book-slug>', bookSlug);
    const response = await this._http.delete(url);
    return response.data;
  }
}

export default new BookVotesService();
